import { render, staticRenderFns } from "./138.vue?vue&type=template&id=36a00f84&"
import script from "./138.vue?vue&type=script&lang=js&"
export * from "./138.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports